import request from '@/utils/request'

let DurationApi = {

  /*时长价格列表*/
  list(data) {
    return request._post('/shop/plus.duration.Index/index', data);
},
/*添加时长价格*/
add(data) {
    return request._post('/shop/plus.duration.Index/add', data);
},
/*修改时长价格*/
edit(data) {
    return request._post('/shop/plus.duration.Index/edit', data);
},
/*删除时长价格*/
del(data) {
    return request._post('/shop/plus.duration.Index/del', data);
},
/*时长价格详情*/
detail(data) {
  return request._post('/shop/plus.duration.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.duration.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.duration.Setting/getSetting', data, errorback);
    },
}
export default DurationApi;



// WEBPACK FOOTER //
// ./src/api/duration.js